<mat-tree
  #tree
  class="c-mat-tree"
  [dataSource]="dataSource"
  [treeControl]="treeControl"
>
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodeToggle
    matTreeNodePadding
    matTreeNodePaddingIndent="10px"
  >
    <button mat-icon-button disabled></button>
    <div class="d-flex justify-content-between w-100">
      <mat-checkbox
        class="checklist-leaf-node align-self-center"
        [checked]="checklistSelection.isSelected(node)"
        (change)="todoLeafItemSelectionToggle(node)"
        ><span title="{{ node.data.text }}">{{
          renderTextCheckbox(node.data.text)
        }}</span></mat-checkbox
      >
      <i *ngIf="node.icon" class="{{ node.icon }}"></i>
      <div class="more-action d-flex">
        <i
          class="fa-solid fa-table cursor-pointer align-self-center"
          (click)="viewTable(node)"
        ></i>

        <button
          class="border-none bg-none"
          [matMenuTriggerFor]="menu"
          aria-label="Example icon-button with a menu"
        >
          <i class="fa-solid fa-ellipsis cursor-pointer"></i>
        </button>
        <mat-menu #menu="matMenu">
          <div>
            <button
              mat-menu-item
              class="h-35px d-flex align-self-center"
              (click)="zoomTo(node)"
            >
              <i
                class="mdi mdi-map-search-outline font-size-16 text-secondary me-2 align-self-center"
              ></i>
              <span class="align-self-center">Phóng tới</span>
            </button>
            <button
              mat-menu-item
              [matMenuTriggerFor]="menuOpacity"
              class="h-35px d-flex align-self-center"
            >
              <i
                class="fa-solid fa-sliders font-size-16 text-warning me-2 align-self-center"
              ></i>
              <span class="align-self-center">Điều chỉnh độ trong</span>
            </button>
            <button mat-menu-item class="h-35px d-flex align-self-center">
              <i
                class="mdi mdi-table-headers-eye font-size-16 text-primary me-2 align-self-center"
              ></i>
              <span class="align-self-center">Xem dữ liệu</span>
            </button>
            <button
              mat-menu-item
              (click)="filter(node)"
              class="h-35px d-flex align-self-center"
            >
              <i
                class="mdi mdi-filter-menu-outline font-size-16 text-delete me-2 align-self-center"
              ></i>
              <span class="align-self-center">Lọc dữ liệu</span>
            </button>
            <button
              *ngIf="node?.data?.legend?.url"
              mat-menu-item
              (click)="viewLegend(node)"
              class="h-35px d-flex align-self-center"
            >
              <i
                class="mdi mdi-map-legend font-size-16 text-delete me-2 align-self-center"
              ></i>
              <span class="align-self-center">Xem chú giải</span>
            </button>
            <button
              mat-menu-item
              class="h-35px d-flex"
              (click)="statistical(node)"
            >
              <i
                class="mdi mdi-clipboard-edit-outline font-size-16 text-delete me-2 align-self-center"
              ></i>
              <span class="align-self-center">Thống kê</span>
            </button>
          </div>
        </mat-menu>
        <mat-menu #menuOpacity="matMenu" class="menu-opacity">
          <div (click)="clickOpacity($event)" class="w-100 px-3 pt-3">
            <div
              class="example-label-container w-100 d-flex justify-content-between mb-2"
            >
              <label id="example-name-label" class="example-name-label"
                >Độ trong</label
              >
              <label class="example-value-label">{{ opacity }}</label>
            </div>
            <mat-slider
              class="p-0"
              (valueChange)="changeOpacity($event, node)"
              value="{{ opacity }}"
              tickInterval="1000"
              step="1"
              min="0"
              max="100"
              aria-label="units"
            ></mat-slider>
          </div>
        </mat-menu>
      </div>
    </div>
  </mat-tree-node>

  <mat-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    matTreeNodePadding
    matTreeNodePaddingIndent="10px"
  >
    <button
      mat-icon-button
      matTreeNodeToggle
      [attr.aria-label]="'Toggle ' + node.code"
    >
      <i
        *ngIf="!treeControl.isExpanded(node)"
        class="fa-solid fa-caret-right"
      ></i>
      <i *ngIf="treeControl.isExpanded(node)" class="fa-solid fa-sort-down"></i>
    </button>
    <!-- <span *ngIf="node.level === 0"><i *ngIf="node.icon" class="{{node.icon}} me-1"></i><strong>{{node.data.text}}</strong></span> -->
    <mat-checkbox
      class="c-mat-checkbox align-self-center"
      [checked]="descendantsAllSelected(node)"
      [indeterminate]="descendantsPartiallySelected(node)"
      (change)="todoItemSelectionToggle(node)"
    >
      <i *ngIf="node.icon" class="{{ node.icon }}"></i>
      <span class="fw-500" title="{{ node.data.text }}">{{
        renderTextCheckbox(node.data.text)
      }}</span>
    </mat-checkbox>
    <!-- <button mat-icon-button (click)="addNewItem(node)">
      <i class="fa-solid fa-plus text-dark"></i>
    </button> -->
  </mat-tree-node>
</mat-tree>

<!-- Copyright 2022 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->
